import React, {Component} from 'react';
import Modal from 'react-bootstrap-modal';
import {t} from 'l10n';

import {Form} from 'form';
import {escape} from 'l10n/utils';

class ModalConfimEmail extends Component {


    render() {
        const { 
            closeFn,
            newEmail,
        } = this.props;

        return (
                <Modal className="change-email" show={true}>
                    <Modal.Body>
                        <div className="close" onClick={closeFn}></div>
                        <p className="modal-title">{t('Confirm your new e-mail')}</p>
                        <div className="form">
                            <Form>
                                <div className="form-group">
                                    <label>{t('A confirmation link has been sent to %1. Please check your mailbox and follow the link to verify your new email address.', escape(newEmail))}</label>
                                </div>
                            </Form>
                        </div>
                    </Modal.Body>
                </Modal>
        )
    }
}

export default ModalConfimEmail;


// WEBPACK FOOTER //
// ./src/components/modals/ModalConfimEmail.js